'use strict';
const qs = require('querystring');
const url = require('url');
const client = {
  https: require('https'),
  http: require('http'),
};

const REDIRECT_CODES = [301, 302, 303, 307];
class SimpleError extends Error {
  constructor() {
    super('Error happened due to simple constraint not being 2xx status code.');
    this.name = 'FR_Simple';
  }
}
class RequestError extends Error {
  constructor(e) {
    super('Error happened reguarding a request: ' + e.message);
    this.name = 'FR_Request_' + e.name;
  }
}

class RequestTimeoutError extends Error {
  constructor(e) {
    super('Error happened reguarding a request: ' + e.message);
    this.name = 'FR_Request_Timeout';
  }
}

class Fasquest {
  constructor() {
    this.agent = {
      http: new client.http.Agent({
        keepAlive: true,
      }),
      https: new client.https.Agent({
        keepAlive: true,
      }),
    };
  }
  request(options, cb = null) {
    if (!cb) {
      return this.requestPromise(options);
    } else {
      this._request(options, (req, res, err) => {
        cb({
          req,
          res,
          err,
        });
      });
    }
  }
  requestPromise(options) {
    return new Promise((resolve, reject) => {
      this._request(options, (req, res, err) => {
        if (err) {
          reject({
            req,
            res,
            err,
          });
        } else {
          resolve(options.resolveWithFullResponse ? res : res.body);
        }
      });
    });
  }
  _request(ops, cb, count = 0) {
    var options = this._setOptions(ops);

    var req = client[options.proto].request(options, (res) => {
      res.body = '';

      res.on('data', (chunk) => {
        res.body += chunk;
      });

      res.on('end', () => {
        if (options.timeout) {
          clearTimeout(t);
        }
        // remove as causes circular references

        if (
          REDIRECT_CODES.indexOf(res.statusCode) !== -1 &&
          count < options.redirect_max
        ) {
          options.uri = url.resolve(options.uri, res.headers.location);
          return this._request(this._setOptions(options), cb, ++count);
        } else {
          if (
            res.headers['content-type'] &&
            res.headers['content-type'].indexOf('json') > -1
          ) {
            try {
              res.body = JSON.parse(res.body);
            } catch (e) {
              // do nothing
            }
          }
          if (options.simple) {
            if (res.statusCode > 299 || res.statusCode < 200) {
              return cb(req, res, new SimpleError());
            }
          }
          return cb(req, res, null);
        }
      });
    });

    if (options.timeout) {
      var t = setTimeout(() => {
        req.destroy();
      }, options.timeout || 60000);
    }

    req.on('error', (e) => {
      var err =
        e.message.indexOf('socket hang up') > -1
          ? new RequestTimeoutError(e)
          : new RequestError(e);

      return cb(req, null, err);
    });

    if (options.body) {
      req.write(options.body);
    }
    req.end();
  }
  _setOptions(opts) {
    var options = {};

    options.simple = opts.simple !== false;
    options.method = opts.method || 'GET';
    options.uri = opts.uri;
    options.timeout = opts.timeout;

    if (opts.qs) {
      var escQS = qs.stringify(opts.qs);

      if (escQS.length > 0) {
        options.uri += (options.uri.indexOf('?') > -1 ? '&' : '?') + escQS;
      }
    }
    options = this._uri_to_options(options.uri, options);
    options.agent = opts.agent || this.agent[opts.proto];
    options.headers = {};
    if (opts.headers) {
      var h = Object.keys(opts.headers);

      for (var i = 0; i < h.length; i++) {
        options.headers[h[i]] = opts.headers[h[i]];
      }
    }
    if (opts.json) {
      options.headers['Content-Type'] = 'application/json';
      if (opts.body) {
        options.body = JSON.stringify(opts.body);
      }
    } else if (opts.form) {
      options.body = qs.stringify(opts.form);

      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      options.headers['Content-Length'] = Buffer.byteLength(options.body);
    } else if (opts.body) {
      options.headers['Content-Length'] = Buffer.byteLength(opts.body);
      if (!options.headers['Content-Type']) {
        options.headers['Content-Type'] = 'text/plain';
      }
      options.body = opts.body;
    }
    if (opts.authorization) {
      if (opts.authorization.basic) {
        options.headers['Authorization'] =
          'Basic ' +
          Buffer.from(
            opts.authorization.basic.client +
              ':' +
              opts.authorization.basic.secret,
            'ascii'
          ).toString('base64');
      } else if (opts.authorization.bearer) {
        options.headers['Authorization'] =
          'Bearer ' + opts.authorization.bearer;
      }
    }
    if (!opts.redirect_max && opts.redirect_max !== 0) {
      options.redirect_max = 5;
    }

    return options;
  }
  _uri_to_options(uri, options) {
    var convertedUri = {
      proto: '',
      path: '',
      port: 80,
      host: '',
    };
    var splitURI = uri.split('://');

    convertedUri.proto = splitURI[0];
    var possiblePort = splitURI[1].indexOf(':');

    if (possiblePort > -1 && !isNaN(splitURI[1][possiblePort + 1])) {
      const pindex = splitURI[1].indexOf('/');

      if (pindex > -1) {
        convertedUri.path = splitURI[1].slice(pindex);
        convertedUri.port = splitURI[1].slice(possiblePort + 1, pindex);
      } else {
        convertedUri.port = splitURI[1].slice(possiblePort + 1);
      }
      convertedUri.host = splitURI[1].slice(0, possiblePort);
    } else {
      convertedUri.port = convertedUri.proto == 'https' ? 443 : 80;
    }
    const hostIndex = splitURI[1].indexOf('/');

    if (hostIndex > -1) {
      convertedUri.path = convertedUri.path || splitURI[1].slice(hostIndex);
      convertedUri.host = convertedUri.host || splitURI[1].slice(0, hostIndex);
    } else {
      convertedUri.path = convertedUri.path || '/';
      convertedUri.host = convertedUri.host || splitURI[1];
    }
    options.proto = convertedUri.proto;
    options.path = convertedUri.path;
    options.port = convertedUri.port;
    options.host = convertedUri.host;
    return options;
  }
}
module.exports = new Fasquest();

/**
 * SDK - importing the SDK for use
 * @param {string} host the hostname to the service (example: http://127.0.0.1)
 * @param {object} opts options that will be appened to every request. [Fasquest Lib Options](https://github.com/Phara0h/Fasquest) (example: {headers: {'API-KEY':'34098hodf'}})
 * @example
 * init
 * ```js
 * const { BillingV2 } = require('./sdk.js')('http://127.0.0.1');
 * ```
 */
function SDK(host, opts) {
  var hostUrl = '';
  var defaultOpts = null;

  if (host) {
    hostUrl = host;
  }
  if (opts) {
    defaultOpts = opts;
  }
  const fasq = new Fasquest();

  /**
   *
   */
  class BillingV2 {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        metricsextra: 'billing/metrics/extra',
        metrics: 'billing/metrics',
        healthcheck: 'billing/health',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * metricsExtra - This endpoint is the endpoint prometheus will scrape to provide real time stats.
     *
     * Path: billing/metrics/extra
     */
    static async metricsExtra(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/metrics/extra`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * metrics - This endpoint returns metrics.
     *
     * Path: billing/metrics
     */
    static async metrics(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/metrics`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * healthCheck - This endpoint returns metrics.
     *
     * Path: billing/health
     */
    static async healthCheck(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/health`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Unlockables() {
      return Unlockables;
    }

    static get Transactions() {
      return Transactions;
    }

    static get Subscriptions() {
      return Subscriptions;
    }

    static get Sift() {
      return Sift;
    }

    static get Reports() {
      return Reports;
    }

    static get Receipts() {
      return Receipts;
    }

    static get Products() {
      return Products;
    }

    static get Midigator() {
      return Midigator;
    }

    static get Inventories() {
      return Inventories;
    }

    static get Integrations() {
      return Integrations;
    }

    static get Giftcards() {
      return Giftcards;
    }

    static get Customers() {
      return Customers;
    }

    static get Dunning() {
      return Dunning;
    }

    static get Coupons() {
      return Coupons;
    }

    static get Charge() {
      return Charge;
    }

    static get Categories() {
      return Categories;
    }

    static get Binroutes() {
      return Binroutes;
    }
  }
  /**
   *
   */
  class Unlockables {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        disable: 'billing/v2/unlockables/domain/:domain/id/:id/disable',
        edit: 'billing/v2/unlockables/domain/:domain/id/:id',
        add: 'billing/v2/unlockables/domain/:domain/add',
        byid: 'billing/v2/unlockables/domain/:domain/id/:id',
        countlist: 'billing/v2/unlockables/domain/:domain/list/count',
        list: 'billing/v2/unlockables/domain/:domain/list',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * disable -
     *
     * Path: billing/v2/unlockables/domain/:domain/id/:id/disable
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id id of item being disabled (example: d67370f5-cc6f-4240-a77d-cb8175decac1)
     */
    static async disable(domain, id, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/unlockables/domain/${domain}/id/${id}/disable`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * edit - This endpoint allows editing of the unlockable whose ID matches that of the path variable. Required properties to edit can be found in the request body.
     *
     * Path: billing/v2/unlockables/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id id of item being edited (example: d67370f5-cc6f-4240-a77d-cb8175decac1)
     * @example
     * body
     * ```json
     * {
     *     "name": "test",
     *     "description": "An edited test unlockable used for testing with domain validation."
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/unlockables/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - This endpoint creates a new unlockable. The required properties can be seen in the request body.
     *
     * Path: billing/v2/unlockables/domain/:domain/add
     * @param {Object} body
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "name": "test",
     *     "description": "credit_card"
     * }
     * ```
     */
    static async add(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/unlockables/domain/${domain}/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - This endpoint returns the unlockable whose ID matches that of the path variable.
     *
     * Path: billing/v2/unlockables/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Token id for the desired gateway (example: 5799464f-3614-4723-ad17-ecf267393660)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/unlockables/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - This endpoint returns the count of all unlockable objects.
     *
     * Path: billing/v2/unlockables/domain/:domain/list/count
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, name = test) (example: name=test)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async countList(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/unlockables/domain/${domain}/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint returns an array of objects where each object is a possible unlockable. An unlockable gives an account access to different reports.
  *
  * Path: billing/v2/unlockables/domain/:domain/list
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: name,description)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, name = test) (example: id=c0000001-b999-441f-a71e-cf32f644e501, name = test/test)
  * @param {any} sort Optional. Column name to sort Unlockables (example: name)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(
      domain,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/unlockables/domain/${domain}/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Transactions {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        countbyaccount:
          'billing/v2/transactions/domain/:domain/account/:account/count',
        byaccount: 'billing/v2/transactions/domain/:domain/account/:account',
        byid: 'billing/v2/transactions/domain/:domain/id/:id',
        countlist: 'billing/v2/transactions/domain/:domain/list/count',
        list: 'billing/v2/transactions/domain/:domain/list',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * countByAccount - This endpoint returns the count of transactions on the account ID matching the path variable.
     *
     * Path: billing/v2/transactions/domain/:domain/account/:account/count
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} account Required. Account Id. (example: 65802135-1732-401e-9240-1096f8379467)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, status = CAPTURED) (example: type=visa,status=CAPTURED)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     * @param {any} product_name Optional. Search product name for this string. (example: getting)
     * @param {any} subscription_name Optional. Search subscription_name for this string. (example: not-getting)
     * @param {any} gateway_name Optional. Search gateway_name for this string.
     * @param {any} total Optional. Search total for this field (example: 11.98)
     * @param {any} filters Optional. Filter fields by (example: type=visa,status=CAPTURED)
     */
    static async countByAccount(
      domain,
      account,
      params,
      skip,
      product_name,
      subscription_name,
      gateway_name,
      total,
      filters,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/transactions/domain/${domain}/account/${account}/count`,
        qs: {
          params,
          skip,
          product_name,
          subscription_name,
          gateway_name,
          total,
          filters,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byAccount - This endpoint returns an array of objects where each object is a transaction on an Account. The account ID matches that of the path variable.
     *
     * Path: billing/v2/transactions/domain/:domain/account/:account
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} account Required. Account Id.  (example: 65802135-1732-401e-9240-1096f8379467)
     * @param {any} limit Optional: Limit results count. (example: 1)
     * @param {any} props Optional: Model's properties to be returned with each Object (example: account_id,payment_id)
     * @param {any} skip Optional. Number of rows to skip. (example: 1)
     * @param {any} product_name Optional. Search product name for this string. (example: getting)
     * @param {any} subscription_name Optional. Search subscription_name for this string. (example: not-getting)
     * @param {any} gateway_name Optional. Search gateway_name for this string. (example: gateway)
     * @param {any} total Optional. Search total for this field (example: 11.98)
     * @param {any} filters Optional. Filter fields by (example: type=visa)
     * @param {any} sort Optional. Sort by field (example: token_id)
     * @param {any} sortDesc Optional. Sort descending (example: true)
     * @param {any} resolve  (example: true)
     */
    static async byAccount(
      domain,
      account,
      limit,
      props,
      skip,
      product_name,
      subscription_name,
      gateway_name,
      total,
      filters,
      sort,
      sortDesc,
      resolve,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/transactions/domain/${domain}/account/${account}`,
        qs: {
          limit,
          props,
          skip,
          product_name,
          subscription_name,
          gateway_name,
          total,
          filters,
          sort,
          sortDesc,
          resolve,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - This endpoint returns the transaction with an ID matching that of the path variable.
     *
     * Path: billing/v2/transactions/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id The transaction id (example: 22a55489-21e6-486b-8211-b2bc550629fb)
     * @param {any} resolve  (example: true)
     */
    static async byId(domain, id, resolve, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/transactions/domain/${domain}/id/${id}`,
        qs: { resolve },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * countList - This endpoint returns a count of all transaction objects.
  *
  * Path: billing/v2/transactions/domain/:domain/list/count
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, status = CAPTURED) (example: type=visa, status = CAPTURED)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
  * @param {any} product_name Optional. Product name substring to match products with fuzzy search and query resulting ids (example: getting)
  * @param {any} subscription_name Optional. Subscription name substring to match subscriptions with fuzzy search and query resulting ids (example: not-getting)
  * @param {any} gateway_name Optional. Gateway name substring to match gateways with fuzzy search and query resulting ids (example: gateway)
  * @param {any} total Optoinal. Total cost to fuzzy search transactions (example: 11.98)
  * @param {any} filters Optional. Generic column filter. Allowed ops are '=', '<>', '>=', '<=', '=ANY'. Allowed colunmns are 'aid', 'status', 'created_at' and 'gateway_id'
 (example: created_at>=2021-10-13T19:00:07.850Z,aid=ANYbob%26%261337swagga)
  */
    static async countList(
      domain,
      params,
      skip,
      product_name,
      subscription_name,
      gateway_name,
      total,
      filters,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/transactions/domain/${domain}/list/count`,
        qs: {
          params,
          skip,
          product_name,
          subscription_name,
          gateway_name,
          total,
          filters,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint returns an array of objects where each object is a transaction.
  *
  * Path: billing/v2/transactions/domain/:domain/list
  * @param {any} domain  
  * @param {any} limit Optional: Limit results count. (example: 3)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: account_id,payment_id,token_id)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} product_name Optional. Product name substring to match products with fuzzy search and query resulting ids (example: getting)
  * @param {any} subscription_name Optional. Subscription name substring to match subscriptions with fuzzy search and query resulting ids (example: not-getting)
  * @param {any} gateway_name Optional. Gateway name substring to match gateways with fuzzy search and query resulting ids (example: gateway)
  * @param {any} total Optoinal. Total cost to fuzzy search transactions (example: 11.98)
  * @param {any} filters Optional. Generic column filter. Allowed ops are '=', '>=', '<=', '=ANY'. Allowed colunmns are 'aid', 'status', 'created_at' and 'gateway_id'

To filter by ranges simply use:
capture_amount>=0,capture_amount<=50

To filter for extra_tracking (non-nested values): 
extra_tracking.midigator_order_guid=ord_ac1aa8ee866c4842b162356018f22fbe (example: type=visa,created_at>=2021-11-13,created_at<=2021-11-16,capture_amount>=0,capture_amount<=50,status=CAPTURED||status=GIFTED)
  * @param {any} sort Optional. Column name to sort transactions (example: token_id)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(
      domain,
      limit,
      props,
      skip,
      product_name,
      subscription_name,
      gateway_name,
      total,
      filters,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/transactions/domain/${domain}/list`,
        qs: {
          limit,
          props,
          skip,
          product_name,
          subscription_name,
          gateway_name,
          total,
          filters,
          sort,
          sortDesc,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Subscriptions {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        edit: 'billing/v2/subscriptions/domain/:domain/id/:id',
        add: 'billing/v2/subscriptions/domain/:domain/add',
        countlist: 'billing/v2/subscriptions/domain/:domain/list/count',
        byids: 'billing/v2/subscriptions/domain/:domain/ids',
        byid: 'billing/v2/subscriptions/domain/:domain/id/:id',
        list: 'billing/v2/subscriptions/domain/:domain/list',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * edit - This endpoint allows editing of a subscription that matches the ID of the path variable.
     *
     * Path: billing/v2/subscriptions/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain Filter by this domain (example: traziventures.com)
     * @param {any} id id of item being edited (example: a981100c-3c8e-4be9-bbc2-6dd0ba0d3a69)
     * @example
     * body
     * ```json
     * {
     *     "name": "AI Talking Fish",
     *     "description": "An intelligent fish that listens to you and gives you life changing advice.",
     *     "enabled": true,
     *     "image_url": "https://www.subupdate.com/images/upd.png",
     *     "products": [
     *         "a981100c-3c8e-4be9-bbc2-6dd0ba0d3a69"
     *     ],
     *     "autorenew": true,
     *     "duration": 60,
     *     "duration_type": "DAYS",
     *     "price_override": 78.90,
     *     "trial_duration": 7,
     *     "trial_duration_type": "DAYS",
     *     "trial_price": 4.99,
     *     "trial_pre_auth_full": false,
     *     "capture_after_trial": false,
     *     "currency_code_override": "USD",
     *     "extra": {}
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/subscriptions/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - This endpoint allows adding a subscription. The required properties can be found on the request body.
     *
     * Path: billing/v2/subscriptions/domain/:domain/add
     * @param {Object} body
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "name": "One Giant Huge Fat Example",
     *     "enabled": true,
     *     "image_url": "https://www.subpeople.com/images/test.png",
     *     "products": ["cf1714c8-4368-4bc0-8e01-c293ef4c61ce", "75ec73a3-49bd-48cd-93ee-0bde758f12d7", "70d0b830-3551-48bb-a59f-52d4a5ad9833"],
     *     "autorenew": true,
     *     "duration": 30,
     *     "description": "An intelligent fish that listens to you.",
     *     "duration_type": "DAYS",
     *     "price_override": 420.69,
     *     "trial_duration": 14,
     *     "trial_duration_type": "DAYS",
     *     "trial_price": 9.99,
     *     "trial_pre_auth_full": true,
     *     "capture_after_trial": true,
     *     "currency_code_override": "BTC",
     *     "extra": {}
     * }
     * ```
     */
    static async add(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/subscriptions/domain/${domain}/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - This endpoint returns a count of all subscription objects.
     *
     * Path: billing/v2/subscriptions/domain/:domain/list/count
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, trial_price=9.99) (example: trial_price=9.99,  enabled = true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     * @param {any} name Optional: substring to match name values (example: Shirt)
     * @param {any} trial_price Optional: substring to match triall_price values (example: 88.5)
     * @param {any} price_override Optional: substring to match price_override values (example: 1)
     */
    static async countList(
      domain,
      params,
      skip,
      name,
      trial_price,
      price_override,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/subscriptions/domain/${domain}/list/count`,
        qs: { params, skip, name, trial_price, price_override },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byIds - This endpoint will return the subscription object with an ID matching that of the path variable.
     *
     * Path: billing/v2/subscriptions/domain/:domain/ids
     * @param {any} domain Filter by this domain (example: traziventures.com)
     * @param {any} ids  (example: da88b626-c9fd-4097-b859-2988c59f5553)
     * @param {any} enabledOnly
     */
    static async byIds(domain, ids, enabledOnly, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/subscriptions/domain/${domain}/ids`,
        qs: { ids, enabledOnly },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - This endpoint will return the subscription object with an ID matching that of the path variable.
     *
     * Path: billing/v2/subscriptions/domain/:domain/id/:id
     * @param {any} domain Filter by this domain (example: traziventures.com)
     * @param {any} id Subscription id. (example: 1b6df25b-0080-4d80-bb7e-4d044f1c2cdf)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/subscriptions/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint will return an array of objects where every object is a subscription.
  *
  * Path: billing/v2/subscriptions/domain/:domain/list
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: name,enabled)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} name Optional: substring to match name values (example: Shirt)
  * @param {any} trial_price Optional: substring to match triall_price values (example: 88.5)
  * @param {any} price_override Optional: substring to match price_override values (example: 1)
  * @param {any} params Optional. Exact match filtering. Comma separated SQL predicates (e.g. account_id=1337e, expire_year = 2024) (example: trial_price=9.99,  enabled=true)
  * @param {any} sort Optional. Column name to sort Subscriptions (example: created_at)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(
      domain,
      limit,
      props,
      skip,
      name,
      trial_price,
      price_override,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/subscriptions/domain/${domain}/list`,
        qs: {
          limit,
          props,
          skip,
          name,
          trial_price,
          price_override,
          params,
          sort,
          sortDesc,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Sift {
    constructor() {}
    static get _postgenClassUrls() {
      return { events: 'events' };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * events - Official docs: [https://sift.com/developers/docs/curl/events-api](https://sift.com/developers/docs/curl/events-api)
     *
     * Path: events
     * @param {Object} body
     * @param {any} return_workflow_status Trigger to synchronously integrate with Workflows.  (example: true)
     * @param {any} return_score Get scores back when sending an event. (example: true)
     * @param {any} abuse_types Request scores for specific abuse types. (example: payment_abuse)
     * @example
     * body
     * ```json
     * {
     *   $type: "$create_order",
     *   $api_key: "5b64963b03617475",
     *   $user_id: "test+blockme@test.com",
     *   $user_email: "test+blockme@test.com",
     *   $site_country: "US",
     *   $billing_address: {
     *     $name: "joe shmoe",
     *   },
     *   $amount: 10640000,
     *   $currency_code: "USD",
     *   $order_id: "test+blockme@test.com_71356-6F324",
     *   $ip: "127.0.0.1",
     *   $brand_name: "traziventures.com",
     *   $site_domain: "traziventures.com",
     *   $seller_user_id: "traziventures.com",
     *   $browser: {
     *     $user_agent: "PostmanRuntime/7.31.3",
     *     $content_language: "en-US",
     *     $accept_language: "en-US",
     *   },
     *   $payment_methods: [
     *     {
     *       $payment_type: "$credit_card",
     *       $payment_gateway: null,
     *       $card_bin: "444433",
     *       $card_last4: "1455",
     *     },
     *   ],
     *   $items: [
     *     {
     *       $item_id: "1da630cd-251c-404d-8c0e-78809489acbc",
     *       $product_title: "Unliimited Full Reports",
     *       $price: 0,
     *       $category: "subscription",
     *       $quantity: 1,
     *     },
     *   ],
     * }
     * ```
     */
    static async events(
      body,
      return_workflow_status,
      return_score,
      abuse_types,
      opts
    ) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `events`,
        qs: { return_workflow_status, return_score, abuse_types },
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Reports {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        activitybyproductperday: 'billing/v2/reports/domain/:domain/apd',
        failedtransactions: 'billing/v2/reports/domain/:domain/ftx',
        recurringbillingperday: 'billing/v2/reports/domain/:domain/rbd',
        ltvmonthly: 'billing/v2/reports/domain/:domain/ltv/monthly/year/:year',
        customerlifetimevalue: 'billing/v2/reports/domain/:domain/clv',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
  * activityByProductPerDay - 
  *
  * Path: billing/v2/reports/domain/:domain/apd
  * @param {any} domain  (example: traziventures.com)
  * @param {any} gateway_name Optional. TODO 
  * @param {any} filters Optional. Generic column filter. Allowed ops are '=', '>=', '<=', '=ANY'. Allowed columns are 'aid', 'status', 'created_at' and 'gateway_id'
To filter by ranges simply use:
capture_amount>=0,capture_amount<=50
 (example: created_at>=2021-11-13,created_at<=2023-11-16)
  */
    static async activityByProductPerDay(domain, gateway_name, filters, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/reports/domain/${domain}/apd`,
        qs: { gateway_name, filters },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * failedTransactions - 
  *
  * Path: billing/v2/reports/domain/:domain/ftx
  * @param {any} domain  (example: traziventures.com)
  * @param {any} gateway_name Optional. TODO 
  * @param {any} filters Optional. Generic column filter. Allowed ops are '=', '>=', '<=', '=ANY'. Allowed columns are 'aid', 'status', 'created_at' and 'gateway_id'
To filter by ranges simply use:
capture_amount>=0,capture_amount<=50
 (example: created_at>=2021-11-13,created_at<=2023-11-16)
  */
    static async failedTransactions(domain, gateway_name, filters, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/reports/domain/${domain}/ftx`,
        qs: { gateway_name, filters },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * recurringBillingPerDay -
     *
     * Path: billing/v2/reports/domain/:domain/rbd
     * @param {any} domain  (example: traziventures.com)
     * @param {any} subscription_ids Optional. Subscription Ids to filter transactions by. (example: 2ad044c8-8b12-4c38-b2f4-a7ef37b15724)
     * @param {any} gateway_ids Optional. Gateway Ids to filter transactions by. (example: 58e4f889-e651-4d70-8c43-22693cf10b77,e7e10d4d-cd61-4b7d-a835-aff31aba062d,4b4456e2-08e4-419d-a1cb-1a4a73ec237c,0af892f1-7c1f-464e-8352-09e9ac44f17b,312ba950-8bd0-4848-8bdb-cbebc0d6b7b4,de332376-201b-437a-96dc-576485f4c150,e65ac7c9-2454-4174-8e7c-1d401a5b8405,6372e9d2-932d-4775-8821-0a0fee3cf8f8)
     * @param {any} aids Optional. AIDs to filter transactions by. (example: 30,26)
     * @param {any} campaign_ids Optional. Campaign Ids to filter transactions by. (example: 20051979740,19928687479)
     * @param {any} filters Optional. Generic column filter for 'updated_at'. (Ex.  updated_at>=2023-08-19T04:00:00Z,updated_at<=2023-08-25T03:59:59Z) (example: updated_at>=2023-12-13T05:00:00Z,updated_at<=2023-12-14T05:00:00Z)
     */
    static async recurringBillingPerDay(
      domain,
      subscription_ids,
      gateway_ids,
      aids,
      campaign_ids,
      filters,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/reports/domain/${domain}/rbd`,
        qs: { subscription_ids, gateway_ids, aids, campaign_ids, filters },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * ltvMonthly -
     *
     * Path: billing/v2/reports/domain/:domain/ltv/monthly/year/:year
     * @param {any} domain  (example: information.com)
     * @param {any} year
     * @param {any} subscription_ids Optional. Subscription IDs to filter by (example: a5ddce3b-a25f-4878-aeac-b2eea0541eb0,8060ba41-d75e-416d-a494-3ee7e45f7662,0b47bb81-96af-4103-bbc5-f764b2b36a76,2b353529-5e67-44bd-b542-f1ac69a247f0,6ffd59c8-d2f3-4d39-8ba6-4db186ded452,68f93c68-7563-441f-af38-3e305014f39e,2040315b-2004-4413-92dc-8b4798a245fc,349525a6-5446-49dc-adaf-57c734cb940d,f058effe-6a34-47d7-9465-0d7fa8f1d3fa,3af375fd-5f2f-44e2-ad8b-f3f2476eb8a1,2ad044c8-8b12-4c38-b2f4-a7ef37b15724,3aecc4bc-6d98-4eca-8fb3-4f7b4d86a495,5acd8f07-4457-4a28-85d8-2f9c95e7ad3a,72ad2b2f-aec6-4f03-8df5-19aa0985a892)
     * @param {any} gateway_ids Optional. Gateway IDs to filter by (example: 58e4f889-e651-4d70-8c43-22693cf10b77,e7e10d4d-cd61-4b7d-a835-aff31aba062d,4b4456e2-08e4-419d-a1cb-1a4a73ec237c,0af892f1-7c1f-464e-8352-09e9ac44f17b,312ba950-8bd0-4848-8bdb-cbebc0d6b7b4,de332376-201b-437a-96dc-576485f4c150,e65ac7c9-2454-4174-8e7c-1d401a5b8405,6372e9d2-932d-4775-8821-0a0fee3cf8f8)
     * @param {any} aids Optional. AIDs to filter by (example: 30,26)
     * @param {any} campaign_ids Optional. Campaign IDs to filter by (example: 20051979740,19928687479)
     * @param {any} type Optional. Type to filter Transactions on report by. (example: visa,master)
     * @param {any} states Optional. States to filter Transactions on the report by. (example: FL,CA,ID,NY,MA)
     * @param {any} device_types  (example: mobile,tablet,desktop,smarttv,wearable)
     * @param {any} browser_types  (example: Chrome,Mobile Safari,GSA,Samsung Internet,DuckDuckGo)
     * @param {any} browser_versions  (example: 117.0.0.0,17.5)
     * @param {any} os  (example: iOS,Android,Chromium OS,Windows,Linux,Mac OS)
     */
    static async ltvMonthly(
      domain,
      year,
      subscription_ids,
      gateway_ids,
      aids,
      campaign_ids,
      type,
      states,
      device_types,
      browser_types,
      browser_versions,
      os,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/reports/domain/${domain}/ltv/monthly/year/${year}`,
        qs: {
          subscription_ids,
          gateway_ids,
          aids,
          campaign_ids,
          type,
          states,
          device_types,
          browser_types,
          browser_versions,
          os,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * customerLifetimeValue - 
  *
  * Path: billing/v2/reports/domain/:domain/clv
  * @param {any} domain  (example: information.com)
  * @param {any} subscription_ids Optional. Subscription IDs to filter by (example: a5ddce3b-a25f-4878-aeac-b2eea0541eb0,8060ba41-d75e-416d-a494-3ee7e45f7662,0b47bb81-96af-4103-bbc5-f764b2b36a76,2b353529-5e67-44bd-b542-f1ac69a247f0,6ffd59c8-d2f3-4d39-8ba6-4db186ded452,68f93c68-7563-441f-af38-3e305014f39e,2040315b-2004-4413-92dc-8b4798a245fc,349525a6-5446-49dc-adaf-57c734cb940d,f058effe-6a34-47d7-9465-0d7fa8f1d3fa,3af375fd-5f2f-44e2-ad8b-f3f2476eb8a1,2ad044c8-8b12-4c38-b2f4-a7ef37b15724,3aecc4bc-6d98-4eca-8fb3-4f7b4d86a495,5acd8f07-4457-4a28-85d8-2f9c95e7ad3a,72ad2b2f-aec6-4f03-8df5-19aa0985a892)
  * @param {any} gateway_ids Optional. Gateway IDs to filter by (example: 58e4f889-e651-4d70-8c43-22693cf10b77,e7e10d4d-cd61-4b7d-a835-aff31aba062d,4b4456e2-08e4-419d-a1cb-1a4a73ec237c,0af892f1-7c1f-464e-8352-09e9ac44f17b,312ba950-8bd0-4848-8bdb-cbebc0d6b7b4,de332376-201b-437a-96dc-576485f4c150,e65ac7c9-2454-4174-8e7c-1d401a5b8405,6372e9d2-932d-4775-8821-0a0fee3cf8f8)
  * @param {any} aids Optional. AIDs to filter by (example: 30,26)
  * @param {any} campaign_ids Optional. Campaign IDs to filter by (example: 20051979740,19928687479)
  * @param {any} filters Optional. Generic column filter. Allowed ops are '=', '>=', '<=', '=ANY'. Allowed column is 'created_at'
To filter by ranges simply use:
created_at>=0,created_at<=50 (example: created_at>=2023-08-19T04:00:00Z,created_at<=2023-08-25T03:59:59Z)
  * @param {any} type Optional. Type to filter Transactions on report by. (example: visa,master)
  * @param {any} states Optional. States to filter Transactions on the report by. (example: FL,CA,ID,NY,MA)
  * @param {any} device_types Optional. Device types to filter transactions. (example: mobile,tablet,desktop,smarttv,wearable)
  * @param {any} browser_types Optional. Browser types to filter transactions. (example: Chrome,Mobile Safari,GSA,Samsung Internet,DuckDuckGo)
  * @param {any} browser_versions Optional. Browser versions to filter transactions. (example: 117.0.0.0,17.5)
  * @param {any} os Optional. Operating systems to filter transactions. (example: iOS,Android,Chromium OS,Windows,Linux,Mac OS)
  */
    static async customerLifetimeValue(
      domain,
      subscription_ids,
      gateway_ids,
      aids,
      campaign_ids,
      filters,
      type,
      states,
      device_types,
      browser_types,
      browser_versions,
      os,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/reports/domain/${domain}/clv`,
        qs: {
          subscription_ids,
          gateway_ids,
          aids,
          campaign_ids,
          filters,
          type,
          states,
          device_types,
          browser_types,
          browser_versions,
          os,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Receipts {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        emailbyaccount:
          'billing/v2/receipts/domain/:domain/account/:account/email',
        emailbytransaction:
          'billing/v2/receipts/domain/:domain/transaction/:transaction/email',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * emailByAccount -
     *
     * Path: billing/v2/receipts/domain/:domain/account/:account/email
     * @param {any} domain domain (example: unmask.com)
     * @param {any} account
     * @param {any} sendTo  (example: email@example.com)
     */
    static async emailByAccount(domain, account, sendTo, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/receipts/domain/${domain}/account/${account}/email`,
        qs: { sendTo },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * emailByTransaction -
     *
     * Path: billing/v2/receipts/domain/:domain/transaction/:transaction/email
     * @param {any} domain domain (example: unmask.com)
     * @param {any} transaction
     * @param {any} sendTo Address to send receipt to if different than email on transaction (example: email@example.com)
     */
    static async emailByTransaction(domain, transaction, sendTo, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/receipts/domain/${domain}/transaction/${transaction}/email`,
        qs: { sendTo },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Products {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        edit: 'billing/v2/products/domain/:domain/id/:id',
        add: 'billing/v2/products/domain/:domain/add',
        countlist: 'billing/v2/products/domain/:domain/list/count',
        list: 'billing/v2/products/domain/:domain/list',
        byid: 'billing/v2/products/domain/:domain/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * edit - This endpoint allows editing of a product. Properties to be updated are set in request body.
     *
     * Path: billing/v2/products/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain Filter by this domain. (example: information.com)
     * @param {any} id Product ID (example: 392395ae-e26f-4b23-987b-cad91702d5ef)
     * @example
     * body
     * ```json
     * {
     *     "name": "Billing V2 Test People Report"
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/products/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - This endpoint adds a new product with properties setup in the request body.
     *
     * Path: billing/v2/products/domain/:domain/add
     * @param {Object} body
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "category_id": "d75b1e32-3fa5-4506-a4aa-e30bb348065c",
     *     "name": "All da reports",
     *     "enabled": false,
     *     "domain": "traziventures.com",
     *     "image_url": "https://www.testpeople.com/images/test.png",
     *     "unlockables_ids": ["c0000001-b999-441f-a71e-cf32f644e501"],
     *     "taxable": true,
     *     "max_uses": null,
     *     "shipping_cost": 1.34,
     *     "shipping_weight": 2.7,
     *     "shipping_dimension_height": 1.0,
     *     "shipping_dimension_length": 2.0,
     *     "shipping_dimension_width": 3.0,
     *     "enable_sale": false,
     *     "sale_price": 8.88,
     *     "price": 9.99,
     *     "extra": {
     *
     *     }
     * }
     * ```
     */
    static async add(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/products/domain/${domain}/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - This endpoing returns a count of all product objects.
     *
     * Path: billing/v2/products/domain/:domain/list/count
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: category=test, enabled=true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     * @param {any} name Optional: substring to match name values (example: getting)
     * @param {any} price Optional: substring to match price values (example: 9)
     * @param {any} sale_price Optional: substring to match sale_price values (example: 3)
     * @param {any} category_name  (example: test)
     * @param {any} category_ids  (example: 46894e36-fa9d-41d9-b7f2-6de4ac6a29b7,478c68c7-2021-4aff-8dee-98c1959eb04d)
     */
    static async countList(
      domain,
      params,
      skip,
      name,
      price,
      sale_price,
      category_name,
      category_ids,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/products/domain/${domain}/list/count`,
        qs: {
          params,
          skip,
          name,
          price,
          sale_price,
          category_name,
          category_ids,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint returns an array of objects where each object is a product.
  *
  * Path: billing/v2/products/domain/:domain/list
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: name,enabled)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} name Optional: substring to match name values (example: getting)
  * @param {any} price Optional: substring to match price values (example: 9)
  * @param {any} sale_price Optional: substring to match sale_price values (example: 3)
  * @param {any} params Optional. Exact match filtering. Comma separated SQL predicates (e.g. account_id=1337e, expire_year = 2024) (example: category_id=46894e36-fa9d-41d9-b7f2-6de4ac6a29b7)
  * @param {any} category_name  (example: testz)
  * @param {any} category_ids  (example: 46894e36-fa9d-41d9-b7f2-6de4ac6a29b7,478c68c7-2021-4aff-8dee-98c1959eb04d)
  * @param {any} sort Optional. Column name to sort Products (example: price)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(
      domain,
      limit,
      props,
      skip,
      name,
      price,
      sale_price,
      params,
      category_name,
      category_ids,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/products/domain/${domain}/list`,
        qs: {
          limit,
          props,
          skip,
          name,
          price,
          sale_price,
          params,
          category_name,
          category_ids,
          sort,
          sortDesc,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - This endpoint will return the product with an ID matching that of the path variable provided.
     *
     * Path: billing/v2/products/domain/:domain/id/:id
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} id  (example: 1d556f15-f27c-483d-8b9e-2ae025ed93f8)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/products/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Midigator {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        preventionresolution:
          'prevention/v1/prevention/:prevention_guid/resolution',
        requestbearertoken: 'auth/v1/auth',
        addorupdateorder: 'orders/v2/order',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * preventionResolution -
     *
     * Path: prevention/v1/prevention/:prevention_guid/resolution
     * @param {Object} body
     * @param {any} prevention_guid GUID from Mitigator. (example: pre_8d4f28bf216c4e66bde10e3efc0747a8)
     * @example
     * body
     * ```json
     * {
     *   "resolution_type": "issued_full_refund",
     *   "other_description": ""
     * }
     * ```
     */
    static async preventionResolution(body, prevention_guid, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `prevention/v1/prevention/${prevention_guid}/resolution`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * requestBearerToken - Official docs: [https://docs.midigator.com/api/auth/](https://docs.midigator.com/api/auth/)

[\*NOTE:](https://docs.midigator.com/api/orders/\*NOTE:) The API secret is passed in the Auth bearer header.
  *
  * Path: auth/v1/auth
  */
    static async requestBearerToken(opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `auth/v1/auth`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * addOrUpdateOrder - Official docs: [https://docs.midigator.com/api/orders/](https://docs.midigator.com/api/orders/)
     *
     * Path: orders/v2/order
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *   "order_id": "test-1",
     *   "order_date": "2019-09-30T09:20:11Z",
     *   "mid": "189250002",
     *   "card_brand": "visa",
     *   "card_last_4": "1883",
     *   "card_first_6": "401288",
     *   "card_exp_month": "04",
     *   "card_exp_year": "2022",
     *   "order_amount": 1030,
     *   "avs": "y",
     *   "cvv": "m",
     *   "email": "jane@example.com",
     *   "phone": "555-254-4925",
     *   "refunded": true,
     *   "refunded_amount": 1030,
     *   "subscription_cycle": 3,
     *   "subscription_parent_id": "56",
     *   "ip_address": "192.168.133.7",
     *   "currency": "USD",
     *   "processor_auth_code": "741256",
     *   "processor_transaction_id": "NMI0983",
     *   "billing_first_name": "Jane",
     *   "billing_last_name": "Doe",
     *   "billing_street_address_1": "123 Sample Address",
     *   "billing_street_address_2": "Apt. B",
     *   "billing_city": "Detroit",
     *   "billing_state": "MI",
     *   "billing_postcode": "48201",
     *   "billing_country": "US",
     *   "marketing_source": "Facebook 234",
     *   "sub_marketing_sources": [
     *     "Age 18-25"
     *   ],
     *   "evidence": {
     *     "shipping_details": [
     *       {
     *         "carrier": "usps",
     *         "tracking_number": "8546315789936",
     *         "first_name": "Jane",
     *         "last_name": "Doe",
     *         "street_address_1": "123 Sample Address",
     *         "street_address_2": "Apt. B",
     *         "city": "Detroit",
     *         "state": "MI",
     *         "postcode": "48201",
     *         "country": "US"
     *       }
     *     ],
     *     "proof": [
     *       {
     *         "type": "login date",
     *         "value": "2019-09-30T09:23:10Z"
     *       }
     *     ]
     *   },
     *   "items": [
     *     {
     *       "id": "1098",
     *       "name": "Widget - Black",
     *       "price": 1030,
     *       "quantity": 1,
     *       "sku": "WID-06-BK-LG"
     *     }
     *   ],
     *   "notes": [
     *     {
     *       "timestamp": "2019-10-04T08:15:45Z",
     *       "value": "CRM API - Customer was refunded"
     *     }
     *   ]
     * }
     * ```
     */
    static async addOrUpdateOrder(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `orders/v2/order`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Inventories {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        disableall: 'billing/v2/inventories/domain/:domain/disable/all',
        disable: 'billing/v2/inventories/domain/:domain/id/:id/disable',
        countlist: 'billing/v2/inventories/domain/:domain/list/count',
        list: 'billing/v2/inventories/domain/:domain/list',
        countbyaccount:
          'billing/v2/inventories/domain/:domain/account/:account/count',
        subscriptionstatus:
          'billing/v2/inventories/domain/:domain/account/:account/subscription/status',
        byaccount: 'billing/v2/inventories/domain/:domain/account/:account',
        byid: 'billing/v2/inventories/domain/:domain/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * disableAll - This endpoint is used by billing watchdog and checks expiry status of all inventories passed in on the request body for expiry status. If there is an expired product it will be deleted and if there is an expired subscription it will be deactivated.
     *
     * Path: billing/v2/inventories/domain/:domain/disable/all
     * @param {Object} body
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "currency_code":"USD",
     *     "line_items": [
     *         {
     *             "enabled": false,
     *             "id": "34e2ce93-f172-4048-96ea-f2abce9fffd4",
     *             "qty": 1,
     *             "type": "product"
     *         }
     *     ]
     * }
     *
     * ```
     */
    static async disableAll(body, domain, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/inventories/domain/${domain}/disable/all`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * disable - This endpoint disables an inventory with an ID that matches that provided in the path parameters.
     *
     * Path: billing/v2/inventories/domain/:domain/id/:id/disable
     * @param {Object} body
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id id of item being disabled (example: e0000001-30ec-4b97-ad2b-c64f062cf528)
     * @example
     * body
     * ```json
     * {}
     * ```
     */
    static async disable(body, domain, id, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/domain/${domain}/id/${id}/disable`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - Returns a list of all inventories on a given domain.
     *
     * Path: billing/v2/inventories/domain/:domain/list/count
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: type=product, enabled = true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async countList(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/inventories/domain/${domain}/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint returns an array of objects where each object is an inventory.
  *
  * Path: billing/v2/inventories/domain/:domain/list
  * @param {any} domain  (example: traziventures.com)
  * @param {any} resolve  (example: true)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: type,enabled)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: type=product, enabled = true)
  * @param {any} sort Optional. Column name to sort Inventories (example: created_at)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(
      domain,
      resolve,
      limit,
      skip,
      props,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/inventories/domain/${domain}/list`,
        qs: { resolve, limit, skip, props, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countByAccount - Returns a count of all inventories that are attached to the account ID that is provided in the path parameters.
     *
     * Path: billing/v2/inventories/domain/:domain/account/:account/count
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} account Account ID to count inventories on (example: 942bc95d-1215-4c28-b884-b7b4377c11c4)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: type=product,enabled=true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
     */
    static async countByAccount(domain, account, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/domain/${domain}/account/${account}/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * subscriptionStatus - Returns an array of objects where each object is an inventory that is attached to the Account ID provided in the path variables.
  *
  * Path: billing/v2/inventories/domain/:domain/account/:account/subscription/status
  * @param {any} domain Domain. (example: traziventures.com)
  * @param {any} account Account ID to search for inventories under (example: 942bc95d-1215-4c28-b884-b7b4377c11c4)
  * @param {any} resolve  (example: true)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: id,enabled,type)
  * @param {any} skip Optional. Number of rows to skip. (example: 1)
  */
    static async subscriptionStatus(
      domain,
      account,
      resolve,
      limit,
      props,
      skip,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/domain/${domain}/account/${account}/subscription/status`,
        qs: { resolve, limit, props, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * byAccount - Returns an array of objects where each object is an inventory that is attached to the Account ID provided in the path variables.
  *
  * Path: billing/v2/inventories/domain/:domain/account/:account
  * @param {any} domain Domain. (example: traziventures.com)
  * @param {any} account Account ID to search for inventories under (example: 942bc95d-1215-4c28-b884-b7b4377c11c4)
  * @param {any} resolve  (example: true)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: id,enabled,type)
  * @param {any} skip Optional. Number of rows to skip. (example: 1)
  */
    static async byAccount(domain, account, resolve, limit, props, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/domain/${domain}/account/${account}`,
        qs: { resolve, limit, props, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - Returns an object that is an inventory matching the ID provided as a path parameter.
     *
     * Path: billing/v2/inventories/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Inventory id. (example: da167840-464c-47cc-b2cc-2eb71b078aee)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/inventories/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Item() {
      return InventoriesItem;
    }

    static get Subscription() {
      return InventoriesSubscription;
    }
  }
  /**
   *
   */
  class InventoriesItem {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        deletebyaccount:
          'billing/v2/inventories/domain/:domain/account/:account/item/:id',
        delete: 'billing/v2/inventories/domain/:domain/item/:id',
        editbyaccount:
          'billing/v2/inventories/domain/:domain/account/:account/item/:id',
        edit: 'billing/v2/inventories/domain/:domain/item/:id',
        add: 'billing/v2/inventories/domain/:domain/account/:id/item/add',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * deleteByAccount - This endpoint allows deletion of an inventory on an account. Account ID and Inventory ID both are required.
     *
     * Path: billing/v2/inventories/domain/:domain/account/:account/item/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} account Account ID (example: c59be2c5-43e2-493e-89d4-44ebd152f202)
     * @param {any} id Inventory ID to delete. (example: 039f941b-ee4f-4b26-baa8-33a627e91efc)
     */
    static async deleteByAccount(domain, account, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/domain/${domain}/account/${account}/item/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * delete - This endpoint deletes the inventory that matches the ID set as the path parameter.
     *
     * Path: billing/v2/inventories/domain/:domain/item/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Inventory ID to delete. (example: 4aeeed7c-b8a4-4549-acd6-06ca759b7bdf)
     */
    static async delete(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/inventories/domain/${domain}/item/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * editByAccount - This endpoint allows editing of an inventory on an account. Both the account ID and Inventory ID are requried as path parameters as well as a request body containing the properties to update.
     *
     * Path: billing/v2/inventories/domain/:domain/account/:account/item/:id
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @param {any} account  (example: 79a50188-a7c3-49ea-b5c3-1a5d4d9ec66d)
     * @param {any} id ID of inventory item being edited. (example: 4aeeed7c-b8a4-4549-acd6-06ca759b7bdf)
     * @example
     * body
     * ```json
     * {
     *     "type": "subscription",
     *     "enabled": false,
     *     "product_id": null,
     *     "coupon_id": null,
     *     "subscription_id": "dbcf0840-4756-4827-82b9-66ad4754c98c",
     *     "giftcard_id": null,
     *     "transaction_id": null,
     *     "uses_left": 7777,
     *     "expires": "2022-08-31T19:49:30.245Z",
     *     "currency_code": "BTC",
     *     "price": 0.03,
     *     "domain": "traziventures.com",
     *     "extra": {}
     * }
     * ```
     */
    static async editByAccount(body, domain, account, id, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/domain/${domain}/account/${account}/item/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * edit - This endpoint allows editing of inventories where the ID matches the path variable.
     *
     * Path: billing/v2/inventories/domain/:domain/item/:id
     * @param {Object} body
     * @param {any} domain  (example: information.com)
     * @param {any} id id of item being edited (example: a8a60230-25e0-4539-9951-5d7a1103a0c1)
     * @example
     * body
     * ```json
     * {
     *    "enabled": false,
     *    "autorenew": false,
     *    "expires": "2024-03-01T09:02:16.301Z"
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/inventories/domain/${domain}/item/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - This endpoing allows adding an inventory. The ID on the path variable is an account ID. The account matching the ID in the path variable must also have a payment method on it to add an inventory.
     *
     * Path: billing/v2/inventories/domain/:domain/account/:id/item/add
     * @param {Object} body
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id Account id for this inventory item. (example: a1b2c3d4-111a-4143-bc46-8676e536f7f2)
     * @example
     * body
     * ```json
     * {
     *     "type": "product",
     *     "enabled": true,
     *     "domain":"traziventures.com",
     *     "product_id": "a0000003-c777-8765-5675-ab32f644e622",
     *     "coupon_id": null,
     *     "subscription_id": "d311a57e-72c9-43cd-81cb-afef9b8b1af6",
     *     "giftcard_id": null,
     *     "transaction_id": null,
     *     "uses_left": 1000,
     *     "expires": null,
     *     "currency_code": "USD",
     *     "price": 9.99,
     *     "extra": {}
     * }
     * ```
     */
    static async add(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/domain/${domain}/account/${id}/item/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class InventoriesSubscription {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        substitute:
          'billing/v2/inventories/subscription/domain/:domain/item/:id/substitute/subscription/:subscription_id',
        renew:
          'billing/v2/inventories/subscription/domain/:domain/item/:id/renew',
        cancel:
          'billing/v2/inventories/subscription/domain/:domain/item/:id/cancel',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * substitute - Substitute an inventory's subscription - Swaps out a subscription and adds a new 'SUBSTITUTE' transaction based on the originial transaction.
     *
     * Path: billing/v2/inventories/subscription/domain/:domain/item/:id/substitute/subscription/:subscription_id
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} id Inventory id. (example: 1e39e805-d101-41f1-a2ec-1424f1feb6e6)
     * @param {any} subscription_id Id of subscription to substitute in for current subscription. (example: acb0b822-80a0-48be-8e65-51a2d8f35e4b)
     * @param {any} reason Gets put in the extra tracking  (example: too%20expensive%20baby!)
     */
    static async substitute(domain, id, subscription_id, reason, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/subscription/domain/${domain}/item/${id}/substitute/subscription/${subscription_id}`,
        qs: { reason },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * renew - This endpoint allows a subscription to be renewed inside the inventory with an ID that matches the path parameter.
     *
     * Path: billing/v2/inventories/subscription/domain/:domain/item/:id/renew
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} id Inventory id. (example: 01cedd51-c3a9-4248-8024-d05f118c45c9)
     * @param {any} sendEmail Optional Boolean: Whether to send email with charge - Default True (example: false)
     */
    static async renew(domain, id, sendEmail, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/subscription/domain/${domain}/item/${id}/renew`,
        qs: { sendEmail },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * cancel - This endpoint allows the cancellation of a subscription in the inventory with the matching ID as the path parameter.
     *
     * Path: billing/v2/inventories/subscription/domain/:domain/item/:id/cancel
     * @param {any} domain Domain of inventory item. (example: traziventures.com)
     * @param {any} id ID of inventory item being canceled. (example: 7db52829-9159-491e-9e16-f3ccf6e9d990)
     * @param {any} reason Gets cancel reason. (example: too poor baby!)
     * @param {any} reason_details gets cancel reason details. (example: Going with competitor xforce)
     * @param {any} immediately Whether access should be removed as if it were the end of the billing cycle. (example: false)
     * @param {any} hide Optional: If TRUE then hide subscriptions that are replaced by a substituted subscription (example: true)
     */
    static async cancel(
      domain,
      id,
      reason,
      reason_details,
      immediately,
      hide,
      opts
    ) {
      var options = {
        method: 'PUT',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/inventories/subscription/domain/${domain}/item/${id}/cancel`,
        qs: { reason, reason_details, immediately, hide },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Integrations {
    constructor() {}
    static get _postgenClassUrls() {
      return {};
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    static get Midigator() {
      return IntegrationsMidigator;
    }
  }
  /**
   *
   */
  class IntegrationsMidigator {
    constructor() {}
    static get _postgenClassUrls() {
      return {};
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    static get Events() {
      return IntegrationsMidigatorEvents;
    }
  }
  /**
   *
   */
  class IntegrationsMidigatorEvents {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        preventionmatch:
          'billing/v2/integrations/midigator/domain/:domain/events/prevention/match',
        rdrmatch:
          'billing/v2/integrations/midigator/domain/:domain/events/rdr/match',
        chargebackmatch:
          'billing/v2/integrations/midigator/domain/:domain/events/chargeback/match',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * preventionMatch - This payload will be sent to your registered URL (Billing) when a Midigator `prevention.match` event occurs.
     *
     * Path: billing/v2/integrations/midigator/domain/:domain/events/prevention/match
     * @param {Object} body
     * @param {any} domain Domain for prevention match. (example: information.com)
     * @example
     * body
     * ```json
     * {
     *   "amount": 10.04,
     *   "arn": "99992989193702154389999",
     *   "card_first_6": "401288",
     *   "card_last_4": "1883",
     *   "crm_account_guid": "crm_2ec227c00d8c11eb82e3e2adcbae8b42",
     *   "currency": "USD",
     *   "event_guid": "evr_d8cb61dea06e48af9b46c1f5160784c3",
     *   "event_timestamp": "2019-09-27T20:42:43Z",
     *   "event_type": "prevention.match",
     *   "merchant_descriptor": "Merchant Descriptor",
     *   "mid": "189250002",
     *   "order_guid": "ord_dfgdefdea06e48af9b46c1f5160784c3",
     *   "order_id": "abcdef123",
     *   "prevention_case_number": "98453223854042",
     *   "prevention_guid": "pre_abcdefdea06e48af9b46c1f5160784c3",
     *   "prevention_timestamp": "2019-09-27T20:42:43Z",
     *   "prevention_type": "ethoca",
     *   "transaction_timestamp": "2019-09-25T21:12:23Z"
     * }
     * ```
     */
    static async preventionMatch(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/integrations/midigator/domain/${domain}/events/prevention/match`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * rdrMatch - This payload will be sent to your registered URL (Billing) when a Midigator `chargeback.match` event occurs.
     *
     * Path: billing/v2/integrations/midigator/domain/:domain/events/rdr/match
     * @param {Object} body
     * @param {any} domain Domain for chargeback. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *   "amount": 10.04,
     *   "arn": "99992989193702154389999",
     *   "auth_code": "741256",
     *   "card_brand": "visa",
     *   "card_first_6": "455676",
     *   "card_last_4": "3886",
     *   "case_number": "27873223854042",
     *   "rdr_case_number": "123456789",
     *   "rdr_guid": "rdr_abcdefdea06e48af9b46c1f5160784c3",
     *   "rdr_date": "2019-09-27",
     *   "rdr_resolution": "Accepted",
     *   "crm_account_guid": "crm_2ec227c00d8c11eb82e3e2adcbae8b42",
     *   "currency": "USD",
     *   "date_received": "2019-09-27",
     *   "due_date": "2019-09-27",
     *   "event_guid": "evr_d8cb61dea06e48af9b46c1f5160784c3",
     *   "event_timestamp": "2019-09-27T20:42:43Z",
     *   "event_type": "rdr.match",
     *   "mid": "189250002",
     *   "transaction_date": "2023-09-8",
     *   "order_guid": "ord_dfgdefdea06e48af9b46c1f5160784c3",
     *   "order_id": "be240439-9ecb-47b9-8878-e1e1fa55e9e8"
     * }
     * ```
     */
    static async rdrMatch(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/integrations/midigator/domain/${domain}/events/rdr/match`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * chargebackMatch - This payload will be sent to your registered URL (Billing) when a Midigator `chargeback.match` event occurs.
     *
     * Path: billing/v2/integrations/midigator/domain/:domain/events/chargeback/match
     * @param {Object} body
     * @param {any} domain Domain for chargeback. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *   "alternate_transaction_id": "order1234",
     *   "amount": 10.04,
     *   "arn": "99992989193702154389999",
     *   "auth_code": "741256",
     *   "card_brand": "visa",
     *   "card_first_6": "401288",
     *   "card_last_4": "1883",
     *   "case_number": "27873223854042",
     *   "chargeback_date": "2019-09-27",
     *   "chargeback_guid": "cbc_xyzdefdea06e48af9b46c1f5160784c3",
     *   "crm_account_guid": "crm_2ec227c00d8c11eb82e3e2adcbae8b42",
     *   "currency": "USD",
     *   "date_received": "2019-09-27",
     *   "due_date": "2019-09-27",
     *   "event_guid": "evr_d8cb61dea06e48af9b46c1f5160784c3",
     *   "event_timestamp": "2019-09-27T20:42:43Z",
     *   "event_type": "chargeback.match",
     *   "mid": "189250002",
     *   "order_guid": "ord_dfgdefdea06e48af9b46c1f5160784c3",
     *   "order_id": "abcdef123",
     *   "processor_transaction_date": "2019-09-30T09:20:11Z",
     *   "processor_transaction_id": "NMI0983",
     *   "reason_code": "10.4",
     *   "reason_description": "Other Fraud: Card-Absent Environment"
     * }
     * ```
     */
    static async chargebackMatch(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/integrations/midigator/domain/${domain}/events/chargeback/match`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Giftcards {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        edit: 'billing/v2/giftcards/domain/:domain/id/:id',
        add: 'billing/v2/giftcards/domain/:domain/add',
        countlist: 'billing/v2/giftcards/domain/:domain/list/count',
        list: 'billing/v2/giftcards/domain/:domain/list',
        byid: 'billing/v2/giftcards/domain/:domain/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * edit - This endpoint allows editing of a gift card with the ID matching the path variable. The request body can update most fields.
     *
     * Path: billing/v2/giftcards/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id id of item being edited (example: 8b836d9f-24c0-48ea-827b-bb1b2c4ef078)
     * @example
     * body
     * ```json
     * {
     *     "enabled": false,
     *     "currency_code": "BTC",
     *     "starting_balance": 2.0,
     *     "current_balance": 1.0,
     *     "expire_date": "2033-08-31T19:49:30.245Z",
     *     "claimed": true,
     *     "extra": {}
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/giftcards/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - This endpoint adds a gift card. The request body is required.
     *
     * Path: billing/v2/giftcards/domain/:domain/add
     * @param {Object} body
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "enabled": true,
     *     "currency_code": "USD",
     *     "starting_balance": 99.99,
     *     "current_balance": null,
     *     "expire_date": null,
     *     "claimed": false,
     *     "extra": {}
     * }
     * ```
     */
    static async add(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/giftcards/domain/${domain}/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - This endpoint returns a count of all gift cards in the system
     *
     * Path: billing/v2/giftcards/domain/:domain/list/count
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: currency_code=USD, enabled=true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async countList(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/giftcards/domain/${domain}/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint returns an array of objects where each object is a gift card
  *
  * Path: billing/v2/giftcards/domain/:domain/list
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: pin,enabled)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: enabled=false)
  * @param {any} sort Optional. Column name to sort Giftcards (example: created_at)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(
      domain,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/giftcards/domain/${domain}/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - This endpoint will find a giftcard with the matching ID as the path variable.
     *
     * Path: billing/v2/giftcards/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Giftcard id. (example: c495b169-5e98-4d3b-a5fb-cfca74877eef)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/giftcards/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Customers {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        countlist: 'billing/v2/customers/domain/:domain/list/count',
        list: 'billing/v2/customers/domain/:domain/list',
        byid: 'billing/v2/customers/domain/:domain/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
  * countList - This endpoint returns a list of all available customers objects.
  *
  * Path: billing/v2/customers/domain/:domain/list/count
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} params Optional: Filter results by fields from, the payments or transactions tables. Abiguous fields will default to the payments table (e.g. id=a1234... would filter by payment id not transaction id).

You can also filter by email address, however this wiill ignore other parameters due to using the travelling database instead of the billing. (example: token=KPObpRNTjaqHyx7p10vu1hd4EGo)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 10)
  */
    static async countList(domain, params, limit, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/customers/domain/${domain}/list/count`,
        qs: { params, limit, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint returns an array of objects where ever object is a customer account.
  *
  * Path: billing/v2/customers/domain/:domain/list
  * @param {any} domain  (example: information.com)
  * @param {any} params Optional: Filter results by fields from, the payments or transactions tables. Abiguous fields will default to the payments table (e.g. id=a1234... would filter by payment id not transaction id).

You can also filter by email address, however this wiill ignore other parameters due to using the travelling database instead of the billing. (example: email=paypal+testy+3@test.com)
  * @param {any} limit Optional: Limit results count. (example: 100)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 5)
  * @param {any} sort  (example: created_on)
  * @param {any} sortDesc  (example: true)
  */
    static async list(domain, params, limit, skip, sort, sortDesc, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/customers/domain/${domain}/list`,
        qs: { params, limit, skip, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - This endpoint will retrieve a customer by the provided ID in the path variables.
     *
     * Path: billing/v2/customers/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Travelling account id. (example: a79fcd0e-d7d6-4b17-bcc8-f1b61b311b7e)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/customers/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Dunning {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        updatesortorder:
          'billing/v2/dunning/domain/:domain/id/:id/order/:order',
        deletebyid: 'billing/v2/dunning/domain/:domain/id/:id',
        edit: 'billing/v2/dunning/domain/:domain/id/:id',
        add: 'billing/v2/dunning/domain/:domain/add',
        countlist: 'billing/v2/dunning/domain/:domain/list/count',
        list: 'billing/v2/dunning/domain/:domain/list',
        byid: 'billing/v2/dunning/domain/:domain/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * updateSortOrder - Endpoint to update sort order on Dunning items by ID.
     *
     * Path: billing/v2/dunning/domain/:domain/id/:id/order/:order
     * @param {any} domain Domain of the item to be updated. (example: traziventures.com)
     * @param {any} id ID of the item to update.
     * @param {any} order Sort order to update the item to. (example: 0)
     */
    static async updateSortOrder(domain, id, order, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/dunning/domain/${domain}/id/${id}/order/${order}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * deleteById - This endpoint will delete the dunning item that matches the ID in the path variables.
     *
     * Path: billing/v2/dunning/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id ID of payment to be deleted. (example: c0000004-547e-42c8-89ff-37eb04a15c43)
     */
    static async deleteById(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/dunning/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * edit - This endpoint allows the editing of an already existing dunning item.
     *
     * Path: billing/v2/dunning/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id id of item being edited (example: a489ad1b-74a6-4826-8e58-f963fcca4d07)
     * @example
     * body
     * ```json
     * {
     *     "duration": 2,
     *     "duration_type": "WEEKS"
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/dunning/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - This endpoint allows the addition of a new dunning item. Request body required along with domain path variable.
     *
     * Path: billing/v2/dunning/domain/:domain/add
     * @param {Object} body
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "percent_off": "0.25",
     *     "amount_off": "0",
     *     "duration": 7,
     *     "duration_type": "DAYS"
     * }
     * ```
     */
    static async add(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/dunning/domain/${domain}/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - Gives back the number of Dunning Items in the database
     *
     * Path: billing/v2/dunning/domain/:domain/list/count
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: percent_off=10.25, duration=0)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async countList(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/dunning/domain/${domain}/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint returns an array of objects where each object is a Dunning.
  *
  * Path: billing/v2/dunning/domain/:domain/list
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: sort_order,duration)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: percent_off=10.25, duration=0)
  * @param {any} sort  (example: sort_order)
  * @param {any} sortDesc  (example: true)
  */
    static async list(
      domain,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/dunning/domain/${domain}/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - This endpoint finds a Dunning object based on the ID sent in the path variables.
     *
     * Path: billing/v2/dunning/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Dunning ID (example: a489ad1b-74a6-4826-8e58-f963fcca4d07)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/dunning/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Coupons {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        deletebyid: 'billing/v2/coupons/domain/:domain/id/:id',
        edit: 'billing/v2/coupons/domain/:domain/id/:id',
        add: 'billing/v2/coupons/domain/:domain/add',
        countlist: 'billing/v2/coupons/domain/:domain/list/count',
        list: 'billing/v2/coupons/domain/:domain/list',
        byid: 'billing/v2/coupons/domain/:domain/id/:id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * deleteById - This endpoint will delete the coupon that matches the ID in the path variables.
     *
     * Path: billing/v2/coupons/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id ID of payment to be deleted. (example: c0000004-547e-42c8-89ff-37eb04a15c43)
     */
    static async deleteById(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/coupons/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * edit - This endpoint allows the editing of an already existing coupon.
     *
     * Path: billing/v2/coupons/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id id of item being edited (example: 2d37dd24-5b96-467e-82a4-f5ebe156781b)
     * @example
     * body
     * ```json
     * {
     *     "name": "Update example",
     *     "enabled": true,
     *     "global_use_count_enabled": false,
     *     "global_use_count": 99999,
     *     "per_customer_use_total": 5,
     *     "use_on_total": false,
     *     "use_on_specific_products": [
     *         "22a55489-21e6-486b-8211-b2bc550629fb"
     *     ],
     *     "use_on_specific_subscription": [
     *         "dbcf0840-4756-4827-82b9-66ad4754c98c"
     *     ],
     *     "expire_date": "2033-08-31T19:49:30.245Z",
     *     "percent_off": null,
     *     "amount_off": 1.69,
     *     "extra": {}
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/coupons/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - This endpoint allows the addition of a new coupon. Request body required along with domain path variable.
     *
     * Path: billing/v2/coupons/domain/:domain/add
     * @param {Object} body
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "name": "Example coupon",
     *     "enabled": false,
     *     "global_use_count_enabled": true,
     *     "global_use_count": 10000,
     *     "per_customer_use_total": 1,
     *     "use_on_total": true,
     *     "use_on_specific_products": [],
     *     "use_on_specific_subscription": [],
     *     "expire_date": "2022-08-31T19:49:30.245Z",
     *     "percent_off": 10.25,
     *     "amount_off": null,
     *     "extra": {}
     * }
     * ```
     */
    static async add(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/coupons/domain/${domain}/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - Gives back the list of possible gateways from https://core.spreedly.com/v1/gateways_options.json
     *
     * Path: billing/v2/coupons/domain/:domain/list/count
     * @param {any} domain Filter by this domain. (example: traziventures.com)
     * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: global_use_count=10000, enabled = true)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async countList(domain, params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/coupons/domain/${domain}/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
  * list - This endpoint returns an array of objects where each object is a coupon.
  *
  * Path: billing/v2/coupons/domain/:domain/list
  * @param {any} domain Filter by this domain. (example: traziventures.com)
  * @param {any} limit Optional: Limit results count. (example: 1)
  * @param {any} props Optional: Model's properties to be returned with each  onject. 
(example: name,enabled, will return objects with the following structure:
{
   "name": "test block for getting",
   "enabled": true
} (example: name,enabled)
  * @param {any} skip Optional. Number of rows to skip before counting. (example: 2)
  * @param {any} params Optional. Comma separated SQL predicates (e.g. account_id=1337e, enabled = true) (example: global_use_count=10000, enabled = true)
  * @param {any} sort Optional. Column name to sort Coupons (example: created_at)
  * @param {any} sortDesc Optional. Boolean value to determine sort direction (example: true)
  */
    static async list(
      domain,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/coupons/domain/${domain}/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - This endpoint finds a coupon object based on the ID sent in the path variables.
     *
     * Path: billing/v2/coupons/domain/:domain/id/:id
     * @param {any} domain  (example: traziventures.com)
     * @param {any} id Coupon id. (example: 3ba0445a-816c-4016-84bf-48b70b5d27e4)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/coupons/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Charge {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        total: 'billing/v2/charge/domain/:domain/total',
        refund:
          'billing/v2/charge/domain/:domain/transaction/:transaction/refund',
        void: 'billing/v2/charge/domain/:domain/transaction/:transaction/void',
        capture:
          'billing/v2/charge/domain/:domain/transaction/:transaction/capture',
        byinventory: 'billing/v2/charge/domain/:domain/inventory',
        bypayment:
          'billing/v2/charge/domain/:domain/payment/:paymentId/account/:account',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * total - This endpoint will total out the line_items included in the request body.
     *
     * Path: billing/v2/charge/domain/:domain/total
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *   "currency_code": "USD",
     *   "line_items": [
     *     {
     *       "id": "a0000004-c777-8765-5675-ab32f644e622",
     *       "qty": 1,
     *       "type": "product"
     *     },
     *     {
     *       "id": "a0000006-b999-1234-2345-bf32f644e622",
     *       "qty": 1,
     *       "type": "subscription"
     *     }
     *   ],
     *   "coupons": [
     *     {
     *       "code": "BIGSAVINGS3000"
     *     }
     *   ],
     *   "giftcards": [
     *     {
     *       "code": "T123-ABCD-56EF-321Z",
     *       "pin": "1337",
     *       "charge_amount": 2
     *     }
     *   ],
     *   "data": {
     *     "ip_country": "US"
     *   }
     * }
     * ```
     */
    static async total(body, domain, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/charge/domain/${domain}/total`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * refund - This endpoing will refund a transaction based on it's Transaction ID. The t-id header also needs to match that of the travelling account ID for which the transaction is tied to.
     *
     * Path: billing/v2/charge/domain/:domain/transaction/:transaction/refund
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} transaction Transaction id. (example: d293bd94-a0c2-4d52-8a7a-603e8297f0e0)
     * @param {any} amount Optional - Specified amount to refund. (example: 42.69)
     * @param {any} percentage Optional: Specified percentage (as integer) of transaction's capture amount to refund. (example: 50)
     * @param {any} cancelSubscription Optional - Set true if you want the associated subscripiont(s) to be cancelled. Defaults to false in code (example: true)
     * @param {any} removeItems Optional - set true if you want to remove items (example: true)
     * @param {any} reasonDetails Optional - Extra details to give reason for refunding (example: Too expensive, should be $0.69)
     */
    static async refund(
      domain,
      transaction,
      amount,
      percentage,
      cancelSubscription,
      removeItems,
      reasonDetails,
      opts
    ) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/domain/${domain}/transaction/${transaction}/refund`,
        qs: {
          amount,
          percentage,
          cancelSubscription,
          removeItems,
          reasonDetails,
        },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * void - This endpoint will void a transaction based on the domain and transaction. The t-id header must also match the account ID of the travelling user.
     *
     * Path: billing/v2/charge/domain/:domain/transaction/:transaction/void
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} transaction Transaction id (example: b20c0455-b41d-4edc-87c7-eb03aac3e9ef)
     * @param {any} cancelSubscription Optional - Set true if you want the associated subscripiont(s) to be cancelled. (example: true)
     * @param {any} removeItems Optional - set true if you want to remove the items (example: true)
     * @param {any} reasonDetails Optional - Extra details to give reason for voiding (example: Not expensive enough - should cost $420.69)
     */
    static async void(
      domain,
      transaction,
      cancelSubscription,
      removeItems,
      reasonDetails,
      opts
    ) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/domain/${domain}/transaction/${transaction}/void`,
        qs: { cancelSubscription, removeItems, reasonDetails },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * capture - This endpoint will attempt to capture a charge on the inventory ID provided in the path variable.
     *
     * Path: billing/v2/charge/domain/:domain/transaction/:transaction/capture
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} transaction Transaction ID (example: b20c0455-b41d-4edc-87c7-eb03aac3e9ef)
     */
    static async capture(domain, transaction, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/domain/${domain}/transaction/${transaction}/capture`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byInventory - This endpoint will charge the inventory provided in the request body.
     *
     * Path: billing/v2/charge/domain/:domain/inventory
     * @param {Object} body
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} force  (example: true)
     * @param {any} retry_rebill optional - if this is false it will not count as a rebill retry (example: true)
     * @example
     * body
     * ```json
     * {
     *   "currency_code": "USD",
     *   "line_items": [
     *     {
     *       "id": "09419cff-0320-4843-ad13-7e9bd08a7d31",
     *       "qty": 1,
     *       "type": "inventory"
     *     }
     *   ],
     *   "coupons": [],
     *   "giftcards": [],
     *   "data": {
     *     "ip_country": "US",
     *     "aid": "16",
     *     "country": "US",
     *     "state": "MA",
     *     "city": "Worcester",
     *     "extra_tracking": {
     *          "random_1": "some data",
     *          "random_2": "some data"
     *     }
     *   }
     * }
     * ```
     */
    static async byInventory(body, domain, force, retry_rebill, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/charge/domain/${domain}/inventory`,
        qs: { force, retry_rebill },
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byPayment - This endpoint charges the tokenized payment method based on the body of the request and creates (joins) the users account with the provided email. Returns a transaction object.
     *
     * Path: billing/v2/charge/domain/:domain/payment/:paymentId/account/:account
     * @param {Object} body
     * @param {any} domain Domain of the charge (example: information.com)
     * @param {any} paymentId id of the payment (example: 84a92d66-fd8b-4a93-92c0-8f85cf097a8e)
     * @param {any} account Required. Account ID of the user to charge. (example: 79a9275f-40c3-449f-9f6b-7b1187604cc1)
     * @param {any} sendEmail Optional Boolean: Whether to send email with charge - Default True (example: false)
     * @example
     * body
     * ```json
     * {
     *   "currency_code": "USD",
     *   "line_items": [
     *     {
     *       "id": "d8c5cfef-3d7b-440b-8a64-3d03a0ade4e5",
     *       "qty": 1,
     *       "type": "product"
     *     }
     *   ],
     *
     *   "data": {
     *     "ip_country": "US"
     *   }
     * }
     * ```
     */
    static async byPayment(body, domain, paymentId, account, sendEmail, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/domain/${domain}/payment/${paymentId}/account/${account}`,
        qs: { sendEmail },
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get ThirdParty() {
      return ChargeThirdParty;
    }

    static get Join() {
      return ChargeJoin;
    }
  }
  /**
   *
   */
  class ChargeThirdParty {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        webhook: 'billing/v2/charge/thirdparty/webhook/domain/:domain',
        activate:
          'billing/v2/charge/thirdparty/activate/domain/:domain/paymentId/:paymentId',
        transactionstate:
          'billing/v2/charge/thirdparty/transactionstate/domain/:domain',
        setup: 'billing/v2/charge/thirdparty/setup/domain/:domain/type/:type',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * webhook -
     *
     * Path: billing/v2/charge/thirdparty/webhook/domain/:domain
     * @param {Object} body
     * @param {any} domain  (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "id": "WH-1GE84257G0350133W-6RW800890C634293G",
     *     "create_time": "2018-08-15T19:14:04.543Z",
     *     "resource_type": "refund",
     *     "event_type": "PAYMENT.CAPTURE.REFUNDED",
     *     "summary": "Customer voided auth",
     *     "resource": {
     *         "seller_payable_breakdown": {
     *             "gross_amount": {
     *                 "currency_code": "USD",
     *                 "value": "0.99"
     *             },
     *             "paypal_fee": {
     *                 "currency_code": "USD",
     *                 "value": "0.02"
     *             },
     *             "net_amount": {
     *                 "currency_code": "USD",
     *                 "value": "0.97"
     *             },
     *             "total_refunded_amount": {
     *                 "currency_code": "USD",
     *                 "value": "1.98"
     *             }
     *         },
     *         "amount": {
     *             "currency_code": "USD",
     *             "value": "0.99"
     *         },
     *         "update_time": "2018-08-15T12:13:29-07:00",
     *         "create_time": "2018-08-15T12:13:29-07:00",
     *         "links": [
     *             {
     *                 "href": "https://api.paypal.com/v2/payments/refunds/1Y107995YT783435V",
     *                 "rel": "self",
     *                 "method": "GET"
     *             },
     *             {
     *                 "href": "https://api.paypal.com/v2/payments/captures/0JF852973C016714D",
     *                 "rel": "up",
     *                 "method": "GET"
     *             }
     *         ],
     *         "id": "1Y107995YT783435V",
     *         "status": "COMPLETED"
     *     },
     *     "invoice_id": "da6cbc82-bb27-4166-9960-d9127f5dd403-- FQWAQ-QKL5L",
     *     "links": [
     *         {
     *             "href": "https://api.paypal.com/v1/notifications/webhooks-events/WH-1GE84257G0350133W-6RW800890C634293G",
     *             "rel": "self",
     *             "method": "GET",
     *             "encType": "application/json"
     *         },
     *         {
     *             "href": "https://api.paypal.com/v1/notifications/webhooks-events/WH-1GE84257G0350133W-6RW800890C634293G/resend",
     *             "rel": "resend",
     *             "method": "POST",
     *             "encType": "application/json"
     *         }
     *     ],
     *     "event_version": "2.0",
     *     "resource_version": "2.0"
     * }
     * ```
     */
    static async webhook(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/thirdparty/webhook/domain/${domain}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * activate -
     *
     * Path: billing/v2/charge/thirdparty/activate/domain/:domain/paymentId/:paymentId
     * @param {any} domain  (example: traziventures.com)
     * @param {any} paymentId  (example: 1af8c0a1-5240-4f5c-8740-8add40265880)
     */
    static async activate(domain, paymentId, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/thirdparty/activate/domain/${domain}/paymentId/${paymentId}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * transactionState -
     *
     * Path: billing/v2/charge/thirdparty/transactionstate/domain/:domain
     * @param {any} domain  (example: information.com)
     */
    static async transactionState(domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/thirdparty/transactionstate/domain/${domain}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * setUp -
     *
     * Path: billing/v2/charge/thirdparty/setup/domain/:domain/type/:type
     * @param {Object} body
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} type Type of third party method requested (paypal, google, apple) (example: paypal)
     * @param {any} account  (example: 8548966f-218e-4962-9504-6bdd2a742f6f)
     * @example
     * body
     * ```json
     * {
     *     "currency_code": "USD",
     *     "line_items": [
     *         {
     *             "id": "bd73bd97-5e40-4b31-90eb-4af07358d931",
     *             "qty": 1,
     *             "type": "subscription"
     *         }
     *     ],
     *     "data": {
     *         "ip_country": "US",
     *         "email": "azothhermes@hotmail.com",
     *         "redirect_url": "https://127.0.0.1/returnUrl",
     *         "firstName": "Chuck",
     *         "lastName": "Beaverhunter",
     *         "city": "Worcester",
     *         "state": "MA",
     *         "extra_tracking": {
     *             "firstName": "Willy",
     *             "lastName": "Testmando",
     *             "city": "Worcester",
     *             "state": "MA",
     *             "aid": "26"
     *         }
     *     }
     * }
     * ```
     */
    static async setUp(body, domain, type, account, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/thirdparty/setup/domain/${domain}/type/${type}`,
        qs: { account },
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class ChargeJoin {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        bypayment:
          'billing/v2/charge/join/domain/:domain/payment/:paymentId/email/:email',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byPayment - This endpoint charges the tokenized payment method based on the body of the request and creates (joins) the users account with the provided email. Returns a transaction object.
     *
     * Path: billing/v2/charge/join/domain/:domain/payment/:paymentId/email/:email
     * @param {Object} body
     * @param {any} domain Domain of the charge (example: information.com)
     * @param {any} paymentId id of the payment
     * @param {any} email User email for new account (example: benjamin.jones+42069@trazi.com)
     * @param {any} sendEmail Optional Boolean: Whether to send email with charge - Default True (example: false)
     * @example
     * body
     * ```json
     * {
     *   "currency_code": "USD",
     *   "line_items": [
     *     {
     *       "id": "1d51fcbc-f567-49da-9aa5-d0bacbee70c9",
     *       "qty": 1,
     *       "type": "subscription"
     *     }
     *   ],
     *
     *   "data": {
     *     "ip_country": "US"
     *   }
     * }
     * ```
     */
    static async byPayment(body, domain, paymentId, email, sendEmail, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/charge/join/domain/${domain}/payment/${paymentId}/email/${email}`,
        qs: { sendEmail },
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Categories {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        edit: 'billing/v2/categories/id/:id',
        add: 'billing/v2/categories/add',
        byid: 'billing/v2/categories/id/:id',
        countlist: 'billing/v2/categories/list/count',
        list: 'billing/v2/categories/list',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * edit - This endpoint allows you to edit a Categories name by using the ID of the category.
     *
     * Path: billing/v2/categories/id/:id
     * @param {Object} body
     * @param {any} id ID of item being edited. (example: 193d87ec-66f4-4965-a100-4741b5b6c455)
     * @example
     * body
     * ```json
     * {
     *     "name": "test category updated for example"
     * }
     * ```
     */
    static async edit(body, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/categories/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add - This endpoint allows creation of a category with only a name in the body.
     *
     * Path: billing/v2/categories/add
     * @param {Object} body
     * @example
     * body
     * ```json
     * {
     *     "name": "Category for Example"
     * }
     * ```
     */
    static async add(body, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/categories/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId - Returns an object with the matching category with searched ID or an error message
     *
     * Path: billing/v2/categories/id/:id
     * @param {any} id ID to find category by (example: 4572020c-9f2b-403e-9dd0-934b86c6e196)
     */
    static async byId(id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/categories/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * countList - This endpoint will return a count of all categories objects
     *
     * Path: billing/v2/categories/list/count
     * @param {any} params Optional. Comma separated params to search by. - Exact match - Spaces are okay (example: name=Hats)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     */
    static async countList(params, skip, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/categories/list/count`,
        qs: { params, skip },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * list - This endpoint returns an array of objects where each object is a category.
     *
     * Path: billing/v2/categories/list
     * @param {any} params Optional: Filter results by fields. - Exact match - Spaces will work (example: name=Hats)
     * @param {any} limit Optional: Limit results count. (example: 2)
     * @param {any} skip Optional. Number of rows to skip before counting. (example: 1)
     * @param {any} sort Optional. Field to sort by (example: name)
     * @param {any} sortDesc Optional. Sort Descending - true || false (example: true)
     */
    static async list(params, limit, skip, sort, sortDesc, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/categories/list`,
        qs: { params, limit, skip, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Binroutes {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        edit: 'billing/v2/binroutes/domain/:domain/id/:id',
        list: 'billing/v2/binroutes/domain/:domain/type/:type/list',
        bygroupid: 'billing/v2/binroutes/domain/:domain/group_id/:group_id',
        byid: 'billing/v2/binroutes/domain/:domain/id/:id',
        bytype: 'billing/v2/binroutes/domain/:domain/type/:type/id/:id',
        deletebyid: 'billing/v2/binroutes/domain/:domain/id/:id',
        add: 'billing/v2/binroutes/domain/:domain/add/type/:type',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * edit -
     *
     * Path: billing/v2/binroutes/domain/:domain/id/:id
     * @param {Object} body
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id Id of Bin Routed to be edited (example: 46181546-f698-4781-a964-30c44effb960)
     * @example
     * body
     * ```json
     * {
     *     "domain": "traziventures.com",
     *     "enabled": true,
     *     "product_id": "d294b187-e726-4cbb-88f7-3b2476750bd9",
     *     "route_product_id": "fc2b0da4-32dd-4d86-9145-00ffb3cd9f33",
     *     "group_id": null
     * }
     * ```
     */
    static async edit(body, domain, id, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/binroutes/domain/${domain}/id/${id}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * list -
     *
     * Path: billing/v2/binroutes/domain/:domain/type/:type/list
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} type subscription or product (example: subscription)
     * @param {any} limit  (example: 1)
     * @param {any} props  (example: sort_order,duration)
     * @param {any} skip  (example: 2)
     * @param {any} params
     * @param {any} sort  (example: sort_order)
     * @param {any} sortDesc  (example: true)
     */
    static async list(
      domain,
      type,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/binroutes/domain/${domain}/type/${type}/list`,
        qs: { limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byGroupId -
     *
     * Path: billing/v2/binroutes/domain/:domain/group_id/:group_id
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} group_id Group Id for route
     */
    static async byGroupId(domain, group_id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/binroutes/domain/${domain}/group_id/${group_id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byId -
     *
     * Path: billing/v2/binroutes/domain/:domain/id/:id
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id Id of bin (example: 5e54bdb6-cd5e-490f-bbb0-ff58dcd1c0f4)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/binroutes/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byType -
     *
     * Path: billing/v2/binroutes/domain/:domain/type/:type/id/:id
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} type Type product or subscription (example: product)
     * @param {any} id id of product or subscription (example: d294b187-e726-4cbb-88f7-3b2476750bd9)
     */
    static async byType(domain, type, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/binroutes/domain/${domain}/type/${type}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * deleteById -
     *
     * Path: billing/v2/binroutes/domain/:domain/id/:id
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id Bin Route Id to be deleted (example: 3fc53b30-bfa4-48bb-823b-6e330cd011e9)
     */
    static async deleteById(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/binroutes/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add -
     *
     * Path: billing/v2/binroutes/domain/:domain/add/type/:type
     * @param {Object} body
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} type subscription or product (example: product)
     * @example
     * body
     * ```json
     * {
     *     "domain": "traziventures.com",
     *     "enabled": true,
     *     "product_id": "d294b187-e726-4cbb-88f7-3b2476750bd9",
     *     "route_product_id": "fc2b0da4-32dd-4d86-9145-00ffb3cd9f33",
     *     "group_id": "c0279d94-9135-4069-a60d-6458a9cd4851"
     * }
     * ```
     */
    static async add(body, domain, type, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/binroutes/domain/${domain}/add/type/${type}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get Bins() {
      return BinroutesBins;
    }

    static get Groups() {
      return BinroutesGroups;
    }
  }
  /**
   *
   */
  class BinroutesBins {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        bulkadd: 'billing/v2/binroutes/bins/domain/:domain',
        deleteall: 'billing/v2/binroutes/bins/domain/:domain',
        deletebyid: 'billing/v2/binroutes/bins/domain/:domain/id/:id',
        bybin: 'billing/v2/binroutes/bins/domain/:domain/bin/:bin',
        bygroupid: 'billing/v2/binroutes/bins/domain/:domain/group/:group_id',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * bulkAdd -
     *
     * Path: billing/v2/binroutes/bins/domain/:domain
     * @param {Object} body
     * @param {any} domain Required. Domain of the Bins to delete. (example: information.com)
     * @example
     * body
     * ```json
     * [
     *     {
     *         "bin": "001699",
     *         "group_id": "63ed87ee-c0b9-4425-a3a1-a9e862fe74b4"
     *     },
     *     {
     *         "bin": "420069",
     *         "group_id": "3d58f7ef-0080-4120-8f38-378ad2068507"
     *     }
     * ]
     * ```
     */
    static async bulkAdd(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/binroutes/bins/domain/${domain}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * deleteAll -
     *
     * Path: billing/v2/binroutes/bins/domain/:domain
     * @param {Object} body
     * @param {any} domain Required. Domain of the Bins to delete. (example: information.com)
     * @example
     * body
     * ```json
     * [
     *     "001699",
     *     "420069"
     * ]
     *
     * ```
     */
    static async deleteAll(body, domain, opts) {
      var options = {
        method: 'PUT',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/binroutes/bins/domain/${domain}`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * deleteById -
     *
     * Path: billing/v2/binroutes/bins/domain/:domain/id/:id
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id Id of the bin to be deleted (example: fa6a6d4d-c5d5-4598-b191-b6f4634b14e2)
     */
    static async deleteById(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/binroutes/bins/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byBin -
     *
     * Path: billing/v2/binroutes/bins/domain/:domain/bin/:bin
     * @param {any} domain  (example: traziventures.com)
     * @param {any} bin  (example: 456789)
     * @param {any} resolve Return array of accoutns for subscriptions or procudures (example: true)
     */
    static async byBin(domain, bin, resolve, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/binroutes/bins/domain/${domain}/bin/${bin}`,
        qs: { resolve },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byGroupId -
     *
     * Path: billing/v2/binroutes/bins/domain/:domain/group/:group_id
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} group_id Id of group (example: cf88712d-2787-4cc4-ac06-ca085c15a406)
     * @param {any} full Return array of objects (example: true)
     */
    static async byGroupId(domain, group_id, full, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/binroutes/bins/domain/${domain}/group/${group_id}`,
        qs: { full },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class BinroutesGroups {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        byid: 'billing/v2/binroutes/groups/domain/:domain/id/:id',
        delete: 'billing/v2/binroutes/groups/domain/:domain/id/:id',
        add: 'billing/v2/binroutes/groups/domain/:domain/add',
        list: 'billing/v2/binroutes/groups/domain/:domain/list',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byId -
     *
     * Path: billing/v2/binroutes/groups/domain/:domain/id/:id
     * @param {any} domain Domain of the bin route group (example: traziventures.com)
     * @param {any} id Id of the Group (example: 80c0e6b7-766a-4b27-a722-9c966e848765)
     */
    static async byId(domain, id, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/binroutes/groups/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * delete -
     *
     * Path: billing/v2/binroutes/groups/domain/:domain/id/:id
     * @param {any} domain Domain (example: traziventures.com)
     * @param {any} id Group Id and associated related bins to be deleted (example: 124e23b5-bc7b-43e1-a442-5cc711695f36)
     */
    static async delete(domain, id, opts) {
      var options = {
        method: 'DELETE',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `billing/v2/binroutes/groups/domain/${domain}/id/${id}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * add -
     *
     * Path: billing/v2/binroutes/groups/domain/:domain/add
     * @param {Object} body
     * @param {any} domain Add by this domain. (example: traziventures.com)
     * @example
     * body
     * ```json
     * {
     *     "name": "Traziventures Test Group 1",
     *     "description": "Traziventures Test Group 1",
     *     "allow_removal": true,
     *     "bins": "123456,234567,345678,456789,123456,234567,345678,456789,123456,234567,345678,456789,123456,234567,345678,456789,123456,234567,345678,456789,123456,234567,345678,456789"
     * }
     * ```
     */
    static async add(body, domain, opts) {
      var options = {
        method: 'POST',
        simple: false,
        uri: hostUrl + '/' + `billing/v2/binroutes/groups/domain/${domain}/add`,
        body,
        json: true,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * list -
     *
     * Path: billing/v2/binroutes/groups/domain/:domain/list
     * @param {any} domain  (example: traziventures.com)
     * @param {any} resolve Show bins array object on group (example: true)
     * @param {any} limit  (example: 1)
     * @param {any} props  (example: sort_order,duration)
     * @param {any} skip  (example: 2)
     * @param {any} params
     * @param {any} sort  (example: sort_order)
     * @param {any} sortDesc  (example: true)
     */
    static async list(
      domain,
      resolve,
      limit,
      props,
      skip,
      params,
      sort,
      sortDesc,
      opts
    ) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl + '/' + `billing/v2/binroutes/groups/domain/${domain}/list`,
        qs: { resolve, limit, props, skip, params, sort, sortDesc },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }

  return {
    BillingV2,
    Unlockables,
    Transactions,
    Subscriptions,
    Sift,
    Reports,
    Receipts,
    Products,
    Midigator,
    Inventories,
    InventoriesItem,
    InventoriesSubscription,
    Integrations,
    IntegrationsMidigator,
    IntegrationsMidigatorEvents,
    Giftcards,
    Customers,
    Dunning,
    Coupons,
    Charge,
    ChargeThirdParty,
    ChargeJoin,
    Categories,
    Binroutes,
    BinroutesBins,
    BinroutesGroups,
  };
}
module.exports = SDK;

